/**
 * useOrderMethods
 * The custom hook which provided to external use via context
 */

import {useContext} from 'react'
import OrderMethodsContext from './order-methods-context'

const useOrderMethods = () => {
  const context = useContext(OrderMethodsContext)
  return context
}

export default useOrderMethods
